import { render, staticRenderFns } from "./TasksDropdown.vue?vue&type=template&id=46834db2&scoped=true&"
import script from "./TasksDropdown.vue?vue&type=script&lang=js&"
export * from "./TasksDropdown.vue?vue&type=script&lang=js&"
import style0 from "./TasksDropdown.vue?vue&type=style&index=0&id=46834db2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46834db2",
  null
  
)

export default component.exports